import { Component, inject, ChangeDetectionStrategy } from '@angular/core';

import { LoadingService } from '../../../core/services/loading.service';

@Component({
  selector: 'app-global-loader',
  standalone: true,
  imports: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './global-loader.component.html',
})
export class GlobalLoaderComponent {
  readonly loadingService = inject(LoadingService);
}
